export default __webpack_public_path__ + "static/media/doubts_no_data.6454257c.png";